import { ErrorResponseDto } from "@desio/api";
import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../store";
import { GeneralReducerType } from "./types";

const generalReducer = (state: RootState) => state.general;

export const loader = (key?: string) => {
  return createSelector(generalReducer,
    (state: GeneralReducerType): boolean => {
      if (key) {
        return state.loader[key] > 0;
      } else {
        return state.generalLoader > 0;
      }
    }
  )
}

export const error = createSelector(
  generalReducer,
  (state: GeneralReducerType): ErrorResponseDto => {
    return state.error;
  }
);

